import client from '@/api/client';
import { BASE_URL, COMM_URL } from '@/constants';
import _ from 'lodash';
import { utils } from '@sfaas/util';

export default {
	selectCommCdTypeList: ({ commCdType, currentPage, pageUnit, commCdTypeName }) => {
		const params = { commCdTypeName, pageUnit, currentPage };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');
		//TODO
		//useYn을 Java에서 삭제할 예정이나 아직 처리되지 않아 우선 강제로 'Y' 부여
		return client.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/useYn/${'Y'}` + queryString).then(res => res.data);
	},
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	selectCommCdList: ({ commCdType, currentPage, pageUnit }) =>
		client
			.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/commCd?currentPage=${currentPage}&pageUnit=${pageUnit}`)
			.then(res => res.data),
	deleteCommCdType: body => client.post(`${BASE_URL}/commonCode/v1/commCdType/delete`, body).then(res => res.data),
	saveCommCdType: body => client.post(`${BASE_URL}/commonCode/v1/commCdType/save`, body).then(res => res.data),
	deleteCommCd: body => client.post(`${BASE_URL}/commonCode/v1/commCd/delete`, body).then(res => res.data),
	saveCommCd: body => client.post(`${BASE_URL}/commonCode/v1/commCd/save`, body).then(res => res.data),
	selectCommCdDescList: ({ commCdType, commCd, currentPage, pageUnit }) => {
		const encoded = encodeURI(
			`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/commCd/${commCd}/commCdDesc?currentPage=${currentPage}&pageUnit=${pageUnit}`
		);
		return client
			.get(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	saveCommCdDescList: ({ commCdType, commCd, commCdDescList }) => {
		const encoded = encodeURI(`${BASE_URL}/commonCode/v1/status/1/commCdType/${commCdType}/commCd/${commCd}/commCdDesc`);
		return client
			.post(encoded, commCdDescList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	deleteCommCdDescList: ({ commCdType, commCd, commCdDescList }) => {
		const encoded = encodeURI(`${BASE_URL}/commonCode/v1/status/3/commCdType/${commCdType}/commCd/${commCd}/commCdDesc`);
		return client
			.post(encoded, commCdDescList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	selectCommCdLangList: ({ langId, langVal, currentPage, pageUnit }) => {
		let queryStr = utils.$sf_objectToQueryString({
			langId,
			langVal,
			currentPage,
			pageUnit
		});
		return client
			.get(`${BASE_URL}/commonCode/v1/commCdLang` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	saveCommCdLangList: commCdLangList => {
		const encoded = encodeURI(`${BASE_URL}/commonCode/v1/status/1/commCdLang`);
		return client
			.post(encoded, commCdLangList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	deleteCommCdLangList: commCdLangList => {
		const encoded = encodeURI(`${BASE_URL}/commonCode/v1/status/3/commCdLang`);
		return client
			.post(encoded, commCdLangList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
